/**
 * `PortalShellContext` — v4 visual-QA fix (2026-10-10).
 *
 * The seven agency section views (ClientsList, AgencyReports,
 * AgencyReferral, AgencyWidget, WhiteLabel, PortalOverview, PortalLeads)
 * are reused in two places:
 *
 *   - Standalone (legacy deep-link alias): each renders its own
 *     max-w-6xl container + `AGENCY` kicker + serif H1.
 *   - Inside `AgencyPortal` (Slice 4): the portal shell already renders
 *     the `AGENCY PORTAL` kicker, the section H1 and a description, and
 *     wraps everything in its own max-w-6xl + flex rail layout. The
 *     per-view container would double the max-width + padding and
 *     duplicate the heading.
 *
 * The portal shell provides `true` from this context; each inner view
 * reads it with `useIsEmbedded()` and skips its own Shell wrapper when
 * embedded.
 *
 * Default is `false` so standalone deep-link usages keep rendering
 * their own heading + container.
 */

import { createContext, useContext } from 'react';

const PortalShellContext = createContext<boolean>(false);

export const PortalShellProvider = PortalShellContext.Provider;

export function useIsEmbedded(): boolean {
  return useContext(PortalShellContext);
}
